import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IWorkerTeamPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';

const WorkerTeamPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: workerTeam,
    loading,
    error,
  } = useObjectPreview<IWorkerTeamPreviewJson>(id, INamedObjectTypes.WorkerTeam);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="project-preview">
      <style jsx>{`
        .project-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: flex-start;
        }

        .project-preview__thing-list > div {
          display: flex;
        }

        .project-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="project-preview__banner">
        <h3 style={{ margin: '0 5px' }}>{workerTeam?.name}</h3>
      </div>
      <div className="project-preview__body">
        <div className="project-preview__thing-list">
          <div>
            <strong>Overview</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/team/${id}`}>
              {`team/${id}`}
            </IsomorphicLink>
          </div>
          <div>
            <strong>Members</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/team/${id}/members`}>
              {`team/${id}/members`}
            </IsomorphicLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkerTeamPreview;
